import React, { Component } from "react";
import { Link } from "react-router-dom";
import InputError from "../components/Error/InputError";
import Rules from "../Helpers/FormRules";
import FormValidator from "../Helpers/FormValidator";
import { createFAQ, getFaqDetails, updateFaq } from '../Actions/faq.js';
import { errorToast, successToast } from '../components/Toast/Toast.js';
import * as _ from "lodash";
import Loader from '../components/Loader/Loader.jsx';
import FroalaEditor from 'react-froala-wysiwyg';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'font-awesome/css/font-awesome.css';

class CreateFaq extends Component {
  constructor(props) {
    super(props);
    this.validator = new FormValidator(Rules.CreateFaq);
    this.state = {
        validation: this.validator.valid(),
        question: "",
        answer: "",
        edit_mode: false,
        isLoading: false,
        faq_id:"",
        config : {
            placeholderText: 'Here is your answer !',
            fontFamilySelection: true,
            fontSizeSelection: true,
            paragraphFormatSelection: true,
            toolbarSticky: false,
            requestWithCredentials: true,
            imagePasteProcess: true,
            imagePaste: true,
            requestWithCORS: false,
            height: 200,
            pluginsEnabled: ['align'],
            toolbarButtons:{

                moreText: {
                    buttons: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting'],
                    align: 'left',
                    buttonsVisible: 2
                },

                moreParagraph: {
                    buttons: ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote'],
                    align: 'left',
                    buttonsVisible: 0
                },

                moreRich: {
                    buttons: ['insertLink', 'insertImage', 'insertVideo', 'insertTable', 'emoticons', 'fontAwesome', 'specialCharacters', 'embedly', 'insertFile', 'insertHR'],
                    align: 'left',
                    buttonsVisible: 0
                },

                moreMisc: {
                    buttons: ['undo', 'redo', 'fullscreen', 'print', 'getPDF', 'spellChecker', 'selectAll', 'html', 'help'],
                    align: 'right',
                    buttonsVisible: 2
                },

                imageUploadURL: 'attachment/upload',
                imageUploadParams: { type: 'image' },
                imageAllowedTypes: ['jpeg', 'jpg', 'png'],
            }
        }    
      }  
      this.formsubmitted = false;
    };

    componentDidMount() {  
        if(this.props.location.id) {
            this.getFaqData(this.props.location.id); 
        }
    }

    getFaqData(faqId){
        this.setState( { isLoading: true });
        getFaqDetails(faqId).then((response)=>{
            const result = response.data.success;
            this.setState({
                question: result.data.question,
                answer: result.data.answer,
                edit_mode: true,
                faq_id: faqId,
                isLoading:false
            });
        }).catch(error =>{
            if (error.response) {
                const errorResult = error.response.data.error;
                this.setState({err:true,message:'Server Error!', isLoading:false});
                errorToast(errorResult.message);
            } 
        });

    }

    onChange(e){
        const { name, value } = e.target;
        this.setState({[name]: value});
    }

    handleModelChange( value ) {
        this.setState({ answer: value });
    }

    onSubmit = e => {
        e.preventDefault();
        const { answer, question, edit_mode, faq_id } = this.state;
        const validation = this.validator.validate(this.state);
        this.setState( { validation, isLoading: true }, () =>{
            this.submitted = true;
            if (validation.isValid) {
                const apiMethod = (edit_mode) ? updateFaq({answer, question }, faq_id): createFAQ({answer, question });
                apiMethod.then((response) =>{
                    let result = response.data;
                    this.setState( { isLoading: false }, () =>{
                        if(result.success){
                            successToast(result.success.message);
                                setTimeout(() => {
                                    this.props.history.push("/admin/faq/faq-list");
                                },1000);
                        } else {
                            errorToast(result.error.message);
                        }
                    });
                }).catch((error)=> {
                    if (error.response) {
                        const errorResult = error.response.data.error;
                        this.setState({err:true,message:'Server Error!', isLoading:false});
                        errorToast(errorResult.message);
                    } 
                });
            } else {
              this.setState({ isLoading:false });
            }
        });
    }
  
  
    render() {
        const { question, answer, isLoading, edit_mode } = this.state;
        let validation = this.submitted ? this.validator.validate(this.state) : this.state.validation;
        return (
        <div className="agenda_session_form_section agenda_padding">  
            <div style={ {height:'95vh', overflow:"auto"} } className="mobile-scrollbar-height">
            <div className="col-md-12 p-0">
                <form className="">
                    <div className="row m-0">
                        <div className="d-md-none col-12 mb-3 ">
                            <h2 className=" m-0 speakers_heading pt-3"> Create FAQ</h2>
                        </div>
                        {/* <div className="col-md-12 p-0"> */}
                            <div className="form-group col-md-12 form-custom custom-height">
                                <label htmlFor="inputEmail4" className="left_label mb-3"> Question <span className="text-danger">*</span> </label>
                                <input className="form-control" 
                                    id="inputEmail4" 
                                    placeholder="Question"
                                    type="text" 
                                    name="question"
                                    value={ question }
                                    onChange={ this.onChange.bind(this) }
                                    tabIndex="1"
                                    autoFocus
                                />
                                <InputError show={validation.question.isInvalid} message={validation.question.message} />
                            </div>
                        {/* </div> */}

                        {/* <div className="form-group col-md-12 form-custom">
                            <label htmlFor="inputEmail4" className="left_label mb-3"> Answer <span className="text-danger">*</span> </label>
                            <FroalaEditor
                                config = {this.state.config} 
                                model={ answer }
                                onModelChange={ this.handleModelChange.bind(this) }
                            />
                            <InputError show={validation.answer.isInvalid} message={validation.answer.message} />
                        </div> */}
                         <div className="form-group col-md-12 form-custom">
                            <label htmlFor="inputEmail4" className="left_label mb-3"> Answer <span className="text-danger">*</span> </label>
                            <textarea className="form-control" 
                                id = "exampleFormControlTextarea1" 
                                rows = "10" 
                                // maxLength = {400}
                                tabIndex = "2"
                                name = "answer" 
                                placeholder ="Here is your answer !" 
                                value = {answer}
                                onChange={this.onChange.bind(this)}
                            >
                            </textarea>
                            <InputError show={validation.answer.isInvalid} message={validation.answer.message} />
                        </div>

                        
                    </div>
                    <div className="col-md-12 mt-3 m-mb-25">
                    <div className="col-md-6 pl-0 m-pr-0">
                        <div className="row">
                            <div className="col-md-6 col-6 m-pr-7">
                                <button  className="btn common_btn blue_btn big_btn fixed_width_btn" 
                                    role="button" 
                                    type="button"
                                    onClick={this.onSubmit.bind(this)}
                                    disabled = { isLoading }
                                    tabIndex="9"
                                > { edit_mode == true ? "Update" : "Save"}
                                </button>
                            </div>    
                            <div className="col-md-6 col-6 m-pl-7">
                                <button  className="btn common_btn gray_btn big_btn fixed_width_btn "
                                    role="button"
                                    type="button"
                                    onClick={ () => { this.props.history.push("/admin/faq/faq-list");} }
                                >
                                    Cancel 
                                </button>
                            </div>    
                        </div>       
                    </div>
                    </div>
                </form>	
            </div>
            </div>
            <Loader isLoading={isLoading}/>
        </div>
        );
    }
}

export default CreateFaq;
